// extracted by mini-css-extract-plugin
export var attachment = "_l8-a";
export var emailContainer = "_l8-4";
export var emailContentPaddedContainer = "_l8-b";
export var emailHeader = "_l8-6";
export var emailIframe = "_l8-3";
export var emailInfoIcon = "_l8-9";
export var emailShortenedSummary = "_l8-e";
export var infoDropdown = "_l8-0";
export var infoRowBoundedContent = "_l8-d";
export var internal = "_l8-5";
export var merchant = "_l8-8";
export var messageInputContainer = "_l8-h";
export var normal = "_l8-7";
export var replyCard = "_l8-f";
export var subtleButton = "_l8-1";
export var subtleButtonIconContainer = "_l8-2";
export var toggleViewRepliesButton = "_l8-c";
export var wrappingText = "_l8-g";